import ActionsDetail from '@/components/actions-detail/index.vue';
import CreateEditIssue from './create-edit-issue/index.vue';
import IssueHeader from './issue-header/index.vue';
import IssueViewDetails from '@/components/issue-view-details/index.vue';

const components = {
    ActionsDetail,
    CreateEditIssue,
    IssueHeader,
    IssueViewDetails
};

export default components;
